import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { http, formatApiErrorDetail } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null); // null = loading, false = logged out
    const [error, setError] = useState("");

    const refresh = useCallback(async () => {
        try {
            const { data } = await http.get("/auth/me");
            setUser(data);
        } catch {
            setUser(false);
        }
    }, []);

    useEffect(() => {
        refresh();
    }, [refresh]);

    const login = useCallback(async (email, password) => {
        setError("");
        try {
            const { data } = await http.post("/auth/login", { email, password });
            setUser(data);
            return true;
        } catch (e) {
            setError(formatApiErrorDetail(e.response?.data?.detail) || e.message);
            return false;
        }
    }, []);

    const logout = useCallback(async () => {
        try {
            await http.post("/auth/logout");
        } catch {
            /* ignore */
        }
        setUser(false);
    }, []);

    return (
        <AuthCtx.Provider value={{ user, error, login, logout, refresh }}>
            {children}
        </AuthCtx.Provider>
    );
}

export const useAuth = () => useContext(AuthCtx);
